"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIComponentLayoutOverride = void 0;
var UIComponentLayoutOverride;
(function (UIComponentLayoutOverride) {
    UIComponentLayoutOverride["Include"] = "include";
    UIComponentLayoutOverride["Exclude"] = "exclude";
})(UIComponentLayoutOverride || (exports.UIComponentLayoutOverride = UIComponentLayoutOverride = {}));
